import { FormattedMessage } from "react-intl";

import { SelectInput } from "@dzambalaorg/mui-inputs-core";
import { TemplateAssetInput } from "@dzambalaorg/mui-inputs-asset";
import { ContractFeatures, ContractStatus, MergeStatus, ModuleType, TokenType } from "@framework/types";
import { Alert, FormGrid } from "@dzambalaorg/ui-kit";

export const MergeDialogForm = () => {
  return (
    <FormGrid columns={[1, 1, 1, 1, 1]}>
      <Alert severity="info" sx={{ mt: 2 }}>
        <FormattedMessage id="alert.mergePrice" />
      </Alert>
      <TemplateAssetInput
        required
        disableClear={false}
        prefix="price"
        contract={{
          data: {
            excludeFeatures: [ContractFeatures.EXTERNAL],
            contractModule: [ModuleType.HIERARCHY],
            contractStatus: [ContractStatus.ACTIVE, ContractStatus.NEW],
          },
        }}
        tokenType={{ disabledOptions: [TokenType.NATIVE, TokenType.ERC20, TokenType.ERC1155] }}
        forceAmount
      />
      <Alert severity="info" sx={{ mt: 2 }}>
        <FormattedMessage id="alert.mergeItem" />
      </Alert>
      <TemplateAssetInput
        required
        autoSelect
        prefix="item"
        contract={{
          data: {
            contractModule: [ModuleType.HIERARCHY],
            contractStatus: [ContractStatus.ACTIVE, ContractStatus.NEW],
          },
        }}
        tokenType={{ disabledOptions: [TokenType.NATIVE, TokenType.ERC20, TokenType.ERC1155] }}
      />
      <SelectInput name="mergeStatus" options={MergeStatus} />
    </FormGrid>
  );
};
